import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { documentsQueryKey } from '../../fetchers/documents/api/use-invalidate-documents';
import type { DocumentsResponse } from '../../fetchers/documents/documents-fetchers';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';

export const useKnowledgeBaseDocuments = (searchTerm: string): UseQueryResult<DocumentsResponse, Error> => {
    const { fetchDocuments } = useApplicationFetchers();

    return useQuery({
        queryFn: async () => {
            const result = await fetchDocuments(searchTerm === '' ? undefined : searchTerm);

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: searchTerm === '' ? documentsQueryKey : [...documentsQueryKey, searchTerm],
    });
};
